"use strict";

var $ = require('jquery'),
    Constants = require('../../constants'),
    LeadModel = require('../../models/Lead');

module.exports = function(agentId, projectId, templateId, comments, buttonText) {
    buttonText = buttonText || 'Submit';
    comments = comments || '';
    var $ContactForm = $([
        '<div class="col-xs-12 white-bg box-shadow margin-bottom-10 as_contact_form" id="AS_ContactFormDiv5" name="AS_ContactFormDiv5">\
	        <div class="row">\
                <div class="col-xs-12">\
                    <p class="blue large"><strong>SEND US A MESSAGE</strong></p>\
                </div>\
            </div>\
            <div class="row">\
                <div class="col-xs-12 col-md-6 form-group-wrap">\
    	            <div class="form-group">\
                        <label>First Name*</label>\
                        <input name="AS_FirstName" class="form-control" id="FirstName" type="text" value="" required="">\
    	            </div>\
    	            <div class="form-group">\
    	                <label>Last Name*</label>\
    	                <input name="AS_LastName" type="text" class="form-control" value="" required="">\
    	            </div>\
    		    </div>\
                <div class="col-xs-12 col-md-6 form-group-wrap">\
                    <div class="form-group">\
                        <label>Email Address*</label>\
                        <input name="AS_Email" type="email" class="form-control" value="" required="">\
                    </div>\
                    <div class="form-group">\
                        <label>Phone</label>\
                        <input name="AS_PhoneNumber" type="text" value="" class="form-control" required="">\
                    </div>\
                </div>\
            </div>\
            <div class="row">\
    		    <div class="col-xs-12 form-group-wrap">\
        		    <div class="form-group">\
        		        <label>Your Message:</label>\
        		        <textarea class="form-control" name="AS_Comments" id="message" rows="5"></textarea>\
                    </div>\
                </div>\
            </div>\
            <div class="row">\
                <div class="col-xs-6">\
                    <input type="button" class="btn btn-primary blue-button myfav width-100 center" name="Go" value="SEND" required="">\
                </div>\
                <div class="col-xs-6">\
                  <div class="btn btn-link" style="float:right; clear: both;"><a href="http://newconstructionhub.com" target="_blank"><img src="//s3.amazonaws.com/www.agentshield.com/static_assets/NCH_Logo_108x25.png"></a></div>\
                </div>\
        	</div>\
		    <div style="clear: both;"></div>\
		</div>'
    ].join(''));

    $ContactForm.find('.blue-button').on('click', function(e) {
        var Lead = new LeadModel(),
            validation,
            errors = [
                'Form Invalid:'
            ];

        if (e) {
            e.preventDefault();
        }

        Lead.set(Lead.parse({
            collectedFromUrl: window.location.href,
            contactMethod: 'AgentToolbox',
            comments: $ContactForm.find('[name="AS_Comments"]').val() || undefined,
            agent: {
                id: agentId
            },
            listing: {
                id: projectId
            },
            brochureTemplate: templateId,
            contactInfo: {
                firstName: $ContactForm.find('[name="AS_FirstName"]').val() || undefined,
                lastName: $ContactForm.find('[name="AS_LastName"]').val() || undefined,
                phoneHome: $ContactForm.find('[name="AS_PhoneNumber"]').val() || undefined,
                email: $ContactForm.find('[name="AS_Email"]').val() || undefined,
                address1: $ContactForm.find('[name="AS_Address1"]').val() || undefined,
                address2: $ContactForm.find('[name="AS_Address2"]').val() || undefined,
                city: $ContactForm.find('[name="AS_City"]').val() || undefined,
                state: $ContactForm.find('[name="AS_State"]').val() || undefined,
                zip: $ContactForm.find('[name="AS_Zip"]').val() || undefined,
                country: $ContactForm.find('[name="AS_Country"]').val() || undefined
            }
        }));

        validation = Lead.validate();

        if (!validation) {
            Lead.save().then(function() {
                $ContactForm.html('<p align="center">Thank you for your inquiry.  Someone will be in touch with you shortly!</p>');
            });
        } else {
            _.each(validation, function(error) {
                errors.push(error)
            });
            alert(errors.join('\r\n'));
        }
    });

    return $ContactForm;
};
